/* eslint-disable max-len */

export default {
  lang: 'German',
  sharing: {
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
  },
  homeScreen: {
    title: 'Unglaublich einzigartig', // Product specific
    stayConnected: 'Bleiben Sie verbunden:',
    comingSoon: 'Demnächst verfügbar',
    messages: 'Nachricht',
  },
  loginScreen: {
    title: 'Professionelles Schulungs- und Vertriebs-Programm für Reiseberater',
    welcome: {
      headerTop: 'Willkommen zum',
      headerBottom: 'Canada Specialist Program', // Product specific
    },
    sellingPoints: { // All selling points can be product specific
      0: 'Unterwegs lernen, fördern und verkaufen',
      1: 'Geräteübergreifendes Multimedia-Training',
      2: 'Abschlussbescheinigung',
      3: 'Vorgefertigte Verkaufspräsentationen',
      4: 'Wirkungsstarke Werbematerialien',
      5: 'Insider-Tipps & Werbeaktionen',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Rechtzeitige Nachrichten und Updates',
    },
    emailPrompt: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um zu bestätigen, dass Sie ein Reiseberater sind.',
    tAndC: {
      agree: 'Indem Sie fortfahren, stimmen Sie unserem',
      privacyPolicy: 'Datenschutz-Bestimmungen ',
      and: 'und',
      termsConditions: 'Geschäftsbedingungen zu.',
    },
    fields: {
      forgot: 'Bitte geben Sie die E-Mail-Adresse an, die Sie bei der Anmeldung für Ihr Canada Specialist Program-Konto verwendet haben. Wir senden Ihnen eine E-Mail, mit der Sie Ihr Passwort zurücksetzen können.',      
      password: 'Passwort',
      passwordConfirm: 'Bestätigen Sie Ihr Passwort',
      agency: 'Agentur',
      email: 'E-Mail *',
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      city: 'Stadt *',
      address: 'Adresse *',
      postalCode: 'Postleitzahl *',
      agencyName: 'Name der Agentur *',
      stateProvince: 'Staat/Provinz *',
      registrationCode: 'Werbe-Code (wahlweise)',
      required: 'Notwendig',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      opt: 'In Kontakt bleiben! Ja, ich möchte mich für Mitteilungen von Destination Canada anmelden, die mich über Neuigkeiten, Veranstaltungen, Incentives, FAMs und mehr auf dem Laufenden halten.',
    },
    noAgent: {
      noAgentButton: 'Ich bin kein Reiseberater',
      title: 'Vielen Dank für Ihr Interesse in Canada.',
      messageWeb: 'Der Inhalt dieser Webseite ist ausschließlich für Reiseveranstalter bestimmt. Um mehr über Canada Specialist zu erfahren, besuchen Sie bitte:',
      messageMobile: 'Einige Inhalte dieser App sind ausschließlich für Reiseveranstalter bestimmt, Sie können jedoch eine Vorschau des Angebots dieser App anzeigen, indem Sie auf "Fortfahren" klicken.',
      continue: 'Fortfahren',
      visitWebsite: 'Webseite besuchen >',
    },
    newUser: 'Neuer Benutzer',
    register: 'Registrieren',
  },
  welcomeScreen: {
    title: 'Willkommen bei der Destination Canada-Verkaufshilfe',
    helloUser: 'Hallo {name}',
    hello: 'Hallo,',
    fromAgency: 'von {agency}',
    notUser: 'Sind Sie Nicht {name}?',
    introOnline: 'Schulen Sie sofort online oder laden Sie den Inhalt vorab, sodass er immer offline verfügbar ist!',
    introOffline: 'Sie haben bereits die neueste Version vorinstalliert. Beginnen Sie zu jeder Zeit und an jedem Ort mit dem Training oder Verkauf!',
    startTraining: 'Fortfahren',
    downloader: {
      preload: 'vorher laden',
      stop: 'stop',
      init: 'Initialisierung ...',
      lastUpdate: 'letztes Update',
    },
  },
  trainingScreens: {
    review: 'Erneut anschauen >',
    unlock: 'Schalten Sie dieses Kapitel frei, indem Sie das Schulungskapitel {number} abschließen.',
    skip: 'Zurückkehren >',
    viewAllTitle: 'Trainingstipp',
    viewAll: 'Um zur nächsten Seite zu gelangen, klickt bitte auf die Symbole, um die ergänzenden Inhalte anzuzeigen. Videos, Karten und andere hilfreiche Informationen wurden bereitgestellt, um das Training zu bereichern und sicherzustellen, dass ihr den PRO-Status erreicht.',
    start: 'Beginnen',
    continue: 'Fortfahren',
    welcome: 'Willkommen in unserem neu gestalteten Trainingsbereich. Schließt einfach Module ab, um dem Ziel, Canada Specialist Gold zu werden, immer näher zu kommen! Rechts seht ihr euren Fortschritt.',
    restart: 'Neustart',
    durationInMinutes: '{number} Minuten',
    percentageComplete: '{number}% abgeschlossen',
    unlock: 'Entsperren Sie dieses Kapitel, indem Sie das Schulungskapitel abschließen',
    unlockSubtitle: 'Entsperren Sie weitere Kapitel, indem Sie Schulungskapitel abschließen.',
    allUnlocked: 'Du hast alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Kurs abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    endReached: 'Du bist am Ende angelangt',
    retainEnd: 'Verwenden Sie die obere Leiste, um in diesem Kapitel zu navigieren, oder drücken Sie die Zurück-Taste, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Sehe, höre und lese mehr',
    trouble: 'Um die Frage beantworten zu können, lies gerne den Inhalt der vorherigen Seite(n) noch einmal durch und versuche es erneut.',
    confirm: 'Bestätige deine Antwort',
    choose: 'Bitte wähle eine Antwort',
    chapter: 'Kapitel',
    essential: 'Grundlegende Module',
    essentialSub: 'Mit Abschluss dieser Module habt ihr den Canada Specialist Bronze Status erreicht.',
    specialization: 'Spezialisierungsmodule',
    specializationSub: 'Schließen Sie diese Module ab, um Ihren Silber Canada Specialist-Status zu erreichen',
    status: 'Aktueller Status',
    completed: '{completed} / {total} abgeschlossen',
  },
  nav: {
    home: 'Startseite',
    train: 'Lernen',
    retain: 'Einprägen & auffrischen',
    directory: 'Verzeichnis',
    promote: 'Promoten',
    sell: 'Verkaufen',
    info: 'Info',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Kontakt',
    reportCard: 'Zertifikat',
    accountSettings: 'Account-Einstellungen',
    messages: 'Nachrichten',
    search: 'Suchen',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Lernen',
    retain: 'Einprägen & auffrischen',
    subapps: 'Canada Partner Mini-Training',
    maintrainings: 'Grundlegende Module',
    subtrainings: 'Das Kanada-Erlebnis',
  },
  pageDescriptions: {
      train: 'Weiterbilden und Experte werden.',
      showroom: '',
      retain: 'Deine Anlaufstelle um dein Wissen aufzufrischen und einzuprägen. Nutze diesen Bereich gerne um Fragen fachmännisch zu beantworten oder sogar als spontane Verkaufspräsentation – jederzeit, überall und von jedem Gerät aus.',
      promote: 'Starten Sie das Gespräch mit Ihren Kunden und Interessenten.',
      sell: 'Beantworten Sie Kundenfragen und schließen Sie den Verkauf ab.',
      favorites: 'Schauen Sie sich Ihre persönlich favorisierten Inhalte an',
      search: 'Alle Inhalte durchsuchen',
      subapps: '',
      maintrainings: 'Absolviert die grundlegenden Module, um das Zertifikat zu erhalten.',
      subtrainings: 'Taucht in Kanadas einzigartige Erlebnisse ein und erreicht den Silber Status.',
     }, 
  general: {
    forgot: 'Passwort vergessen?',
    next: 'nächste',
    previous: 'Zurück',
    submit: 'Absenden',
    back: 'Zurück',
    close: 'Schließen',
    register: 'Registrieren',
    page: 'Seite',
    contact: 'Kontakt',
    search: 'Suchen',
    logIn: 'Einloggen',
    logOut: 'Ausloggen',
    viewItem: '{type} ansehen',
    imageNotFound: 'Bild nicht gefunden',
    noResultsFor: 'Es wurden keine Ergebnisse gefunden für: {query}',
    noFavorites: 'Du hast noch keine Favoriten.',
    noMessages: 'Du hast noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für {query}',
    showAll: 'Zeige alles',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'ist bereits vorhanden',
    pageNotFound: '',
    oops: '',
    overview: 'zurück zur Übersicht',
    complete: 'Kurs abgeschlossen!',
    share: 'Teilen',
    destinations: 'Canada Partner Mini-Training',
    essentials: 'Das Wesentliche von Canada',
    trainingLibrary: 'Schulungsbibliothek',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    courseComplete: 'Kurs abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehen Sie die Drehregler, um die Antwort abzugleichen',
    fitb: 'Fülle die Lücken aus',
    flip: 'Ändern Sie die Nummer entsprechend der Antwort',
    multipleChoice: 'Wählen Sie die richtigen Antwort(en) aus.',
    slider: 'Ziehen Sie den Balken nach rechts und stoppen Sie bei Ihrer Antwort.',
    map: 'Tippen Sie die Antwort auf der Karte an.',
    dropdown: 'Wähle...',
    true: 'Wahr',
    false: 'Falsch',
  },
  cookies: {
    consent: 'Zustimmen',
    optout: 'Aussteigen',
    settings: 'Datenschutzeinstellungen',
    message: 'Sie haben uns nichts über Ihre Datenschutzpräferenzen erzählt! Das ist in Ordnung, aber wir möchten Ihnen die beste Erfahrung mit dem Sales Companion bieten.',
    disabled: 'Sie haben anscheinend die Verwendung von Cookies deaktiviert.',
    use: 'Der {appName} erfordert die Verwendung von Cookies, um Ihnen die bestmögliche Erfahrung zu bieten.',
    details: 'Wozu werden Cookies verwendet?',
    enable: 'So aktivieren Sie Ihre Cookies {here}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Du bist nicht angemeldet',
    title: 'Sie müssen angemeldet sein, um diesen Inhalt anzeigen zu können',
    guest: 'Gast',
  },
  demo: {
    message: '',
    consent: 'Begriffen!',
  },
  share: {
    header: 'Teilen Sie diese Ressource in Ihren bevorzugten sozialen Netzwerken!',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header: 'Anscheinend versuchen Sie, über ein Mobilgerät auf die App {appName} zuzugreifen',
    body: 'Um dieses Programm herunterzuladen, besuchen Sie einfach Ihren App Store und suchen Sie nach {appName} oder klicken Sie auf eine der Schaltflächen unten',
    benefits: {
      header: 'Damit erhalten Sie:',
      1: 'Portabilität',
      2: 'Keine Notwendigkeit für WLAN, trainieren, wann und wo es bequem ist',
      3: 'Verkaufstools und -ressourcen an Ihren Fingerspitzen',
    },
  },
  newTrainingFlow: {
    tip: 'Tipp: Sie verdienen Ihren Status, indem Sie die Module innerhalb jeder Stufe abschließen. Haben Sie großartige Träume und erreichen Sie den Gold Canada Specialist Plattform-Status indem Sie alle Module abschließen!',
    essentialModules: 'Grundlegende Module',
    finishBronze: 'Schließen Sie diese Module ab, um Ihren Bronze-Canada Specialist Plattform-Status zu verdienen',
    specializationModules: 'Spezialisierungsmodule',
    finishSilver: 'Schließen Sie diese Module ab, um Ihren Silber Canada Specialist Plattform-Status zu erreichen',
    partnerModules: 'Partnermodule',
    finishGold: 'Schließen Sie diese Module ab, um Ihren Gold Canada Specialist Plattform-Status zu erreichen',
    currentStatus: 'Aktueller Status',
    pointsToLevel: '{pointsToLevel} {points}',
    reachedRanking: 'bis Sie den {rank} Rang erreicht haben!',
    outOf: '{points} XP von',
    pointsToRank: '{pointsToLevel} XP für Rang erforderlich: ({rank})',
    essential: 'Grundlegende Module',
    essentialSub: 'Schließen Sie diese Module ab, um Ihren Bronze-Canada Specialist Plattform-Status zu verdienen',
    specialization: 'Spezialisierungsmodule',
    specializationSub: 'Schließen Sie diese Module ab, um Ihren Silber Canada Specialist Plattform-Status zu erreichen',
    completed: '{completed} / {total} abgeschlossen',
  },
  points: {
    completed: '{completed} / {total} abgeschlossen',
  }
};